/** Opciones de catálogo upselling (mismo criterio que cotizaciones). */

export const emptyUpsellingLine = () => ({
  id: null,
  item_code: '',
  description: '',
  quantity: 1,
  unit: 'UN',
  estimated_unit_price: 0,
  unit_budget: 0,
  purchase_motive: 'stock',
  sale_id: '',
  buyer_name: '',
  reference_link: '',
});

export const buildUpsellingProductOptions = (rows = []) =>
  [...(Array.isArray(rows) ? rows : [])]
    .filter((row) => String(row.status || 'Activo').trim() !== 'Inactivo')
    .sort((a, b) => Number(b.id || 0) - Number(a.id || 0))
    .map((row) => {
      const code = String(row.upselling_code || row.id || '').trim();
      const name = String(row.product_name || '').trim();
      if (!code || !name) return null;
      const price = Number(row.base_price || 0);
      return {
        value: code,
        name,
        unit: String(row.unit || 'UN').trim() || 'UN',
        unit_price: Number.isFinite(price) ? price : 0,
        label: `${name}${price > 0 ? ` · $${price.toLocaleString('es-CL')}` : ''}`,
      };
    })
    .filter(Boolean);

export const findUpsellingProductOption = (options = [], code = '') => {
  const key = String(code || '').trim();
  if (!key) return null;
  return (options || []).find((option) => String(option.value || '').trim() === key) || null;
};
